// extracted by mini-css-extract-plugin
module.exports = {"summaryTable":"checkout_summaryTable__31D2g","total":"checkout_total__3b8fe","shippingMethod":"checkout_shippingMethod__2ZtcO"};